/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "climate-pollution-4f9e98f3--sprite",
  "use": "climate-pollution-4f9e98f3--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"climate-pollution-4f9e98f3--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><path d=\"M861.039,996.546c0-.212-.106-.353-.248-.353h-8.075c-.142,0-.248.141-.248.353,0,2.082-.106,13.162-.885,19.407-.035.176-.142.282-.248.282h-.425c-.142,0-.248-.141-.248-.353v-10.726c0-.176-.106-.353-.248-.353h-1.593a.176.176,0,0,0-.142.071l-3.294,3.1c-.177.176-.425,0-.425-.282v-2.541c0-.176-.106-.353-.248-.353h-1.593a.176.176,0,0,0-.142.071l-4.639,4.375a.387.387,0,0,0-.106.282v11.009c0,.176.106.353.248.353h24.26c.177,0,.283-.212.248-.423-.319-2.435-2.125-15.138-1.948-23.924Zm-19.974,19.795c-.885,0-1.629-1.164-1.629-2.611s.708-2.611,1.629-2.611,1.629,1.164,1.629,2.611S841.95,1016.341,841.065,1016.341Zm6.021,0c-.885,0-1.629-1.164-1.629-2.611s.708-2.611,1.629-2.611,1.629,1.164,1.629,2.611-.709,2.611-1.63,2.611Z\" transform=\"translate(-830.009 -988.559)\" fill=\"currentColor\" /><path d=\"M852.5,993.887a.4.4,0,0,1-.292-.485l0-.015a.613.613,0,0,1,.685-.432l.288-.18a.971.971,0,0,1-.141-.654,1.188,1.188,0,0,1,1.3-.865,1.011,1.011,0,0,1,.462.145,1.439,1.439,0,0,1,1.189-.5,1.007,1.007,0,0,1,.978,1.038.686.686,0,0,1-.005.079.576.576,0,0,1,.468.324h.072a1.4,1.4,0,0,1,1.153-.5,1.007,1.007,0,0,1,.978,1.038.686.686,0,0,1-.005.079.576.576,0,0,1,.54.468.432.432,0,0,1,.331.514l-.007.026-.072.144a.937.937,0,0,1-.036,1.081,1.261,1.261,0,0,1-1.513.36,1.166,1.166,0,0,1-.36-.36,1.2,1.2,0,0,1-.757.18,1.3,1.3,0,0,1-.793.18l-.468-.18a1.37,1.37,0,0,1-1.225.432.938.938,0,0,1-.649-.324,1.3,1.3,0,0,1-.721.108.936.936,0,0,1-.9-1.081.652.652,0,0,1-.4-.36A.324.324,0,0,1,852.5,993.887Z\" transform=\"translate(-830.009 -988.559)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
